/** Escapes a value for safe interpolation inside a CSS double-quoted string
 * (e.g. inside `url("...")` or `content: "..."`). Without this, a merchant
 * with permission to write portal customizations could inject `") { ... }`
 * to escape the URL token, close the surrounding rule, and inject arbitrary
 * CSS rules into every customer session — including attribute-selector
 * exfiltration of form data. */
export function escapeCssString(value: string): string {
  return value.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
}
